import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { language, changeLanguage, t } = useLanguage();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <Logo className="h-10 w-10 object-contain" />
            <span className="text-xl font-bold gold-gradient">PEXADIA</span>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`transition-colors ${isActive('/') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.home}
            </Link>
            <Link 
              to="/services" 
              className={`transition-colors ${isActive('/services') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.activities}
            </Link>
            <Link 
              to="/secteurs" 
              className={`transition-colors ${isActive('/secteurs') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.sectors}
            </Link>
            <Link 
              to="/workflows" 
              className={`transition-colors ${isActive('/workflows') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.workflows}
            </Link>
            <Link 
              to="/faq" 
              className={`transition-colors ${isActive('/faq') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.faq}
            </Link>
            <Link 
              to="/louise-trinit-ia" 
              className={`transition-colors ${isActive('/louise-trinit-ia') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.louise}
            </Link>
            <div className="flex items-center gap-2 px-2">
              <button
                onClick={() => changeLanguage('fr')}
                className={`px-3 py-1 text-sm font-bold transition-colors ${
                  language === 'fr' ? 'text-[#d4af37] border-b-2 border-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'
                }`}
              >
                FR
              </button>
              <span className="text-gray-500">|</span>
              <button
                onClick={() => changeLanguage('en')}
                className={`px-3 py-1 text-sm font-bold transition-colors ${
                  language === 'en' ? 'text-[#d4af37] border-b-2 border-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'
                }`}
              >
                EN
              </button>
            </div>
            <Link 
              to="/contact" 
              className="px-6 py-2 gold-bg text-black font-bold rounded-full hover:scale-105 transition-transform"
            >
              {t.nav.cta}
            </Link>
          </div>

          <button 
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4">
            <Link 
              to="/" 
              onClick={() => setIsMenuOpen(false)}
              className={`block transition-colors ${isActive('/') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.home}
            </Link>
            <Link 
              to="/services" 
              onClick={() => setIsMenuOpen(false)}
              className={`block transition-colors ${isActive('/services') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.activities}
            </Link>
            <Link 
              to="/secteurs" 
              onClick={() => setIsMenuOpen(false)}
              className={`block transition-colors ${isActive('/secteurs') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.sectors}
            </Link>
            <Link 
              to="/workflows" 
              onClick={() => setIsMenuOpen(false)}
              className={`block transition-colors ${isActive('/workflows') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.workflows}
            </Link>
            <Link 
              to="/faq" 
              onClick={() => setIsMenuOpen(false)}
              className={`block transition-colors ${isActive('/faq') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.faq}
            </Link>
            <Link 
              to="/louise-trinit-ia" 
              onClick={() => setIsMenuOpen(false)}
              className={`block transition-colors ${isActive('/louise-trinit-ia') ? 'text-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'}`}
            >
              {t.nav.louise}
            </Link>
            <div className="flex items-center gap-2 py-2">
              <button
                onClick={() => changeLanguage('fr')}
                className={`px-3 py-1 text-sm font-bold transition-colors ${
                  language === 'fr' ? 'text-[#d4af37] border-b-2 border-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'
                }`}
              >
                FR
              </button>
              <span className="text-gray-500">|</span>
              <button
                onClick={() => changeLanguage('en')}
                className={`px-3 py-1 text-sm font-bold transition-colors ${
                  language === 'en' ? 'text-[#d4af37] border-b-2 border-[#d4af37]' : 'text-gray-400 hover:text-[#d4af37]'
                }`}
              >
                EN
              </button>
            </div>
            <Link 
              to="/contact" 
              onClick={() => setIsMenuOpen(false)}
              className="block px-6 py-2 gold-bg text-black font-bold rounded-full text-center"
            >
              {t.nav.cta}
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

